import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function PTHero() {
  return <section className="bg-black pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] relative overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-1757">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full" data-id="element-1758">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20" data-id="element-1759">
          <AnimateOnScroll className="w-full lg:w-[50%]" data-id="element-1760">
            <div className="mb-6" data-id="element-1761">
              <span className="text-[#666666] text-[13px] font-body" data-id="element-1762">
                <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-1763">
                  Treatments
                </a>{' '}
                / Injectables
              </span>
            </div>

            <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-1764">
              Be PASSIONATE
            </span>

            <h1 className="text-[32px] sm:text-5xl lg:text-[64px] uppercase text-white tracking-tight mb-2 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-1765">
              PDO THREADS
            </h1>

            <p className="font-serif italic text-white/80 text-xl lg:text-2xl mb-8" data-id="element-1766">
              in a nutshell
            </p>

            <p className="text-[#B0B0B0] text-base leading-[1.7] font-body" data-id="element-1767">
              One of the most transformative, non-invasive treatments that eases
              loose and sagging skin is PDO Threads. By utilizing bio-friendly
              threads made of Polydioxanone, PDO Threads tighten, lift and
              rejuvenate sagging skin and promote collagen production. One of
              the key advantages lies in the natural-looking results they
              provide to subtly improve facial or body contours. At Be CLINICAL,
              we are proud to offer PDO Threads for stunning results.
            </p>

            <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-1768">
              SCHEDULE CONSULTATION
            </Button>
          </AnimateOnScroll>

          <AnimateOnScroll className="w-full lg:w-[50%] h-[300px] lg:h-[600px]" delay={200} data-id="element-1769">
            <div className="w-full h-full overflow-hidden shadow-2xl" data-id="element-1770">
              <img src="https://cdn.magicpatterns.com/uploads/urovBWEzLcsWKvEiQqkqB2/PDO-Threads.jpg" alt="PDO Threads Treatment" className="w-full h-full object-cover" data-id="element-1771" />
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}